import { useRecoilValue } from 'recoil';
import { Box, Button, Paper, Typography } from '@mui/material';
import { useState } from 'react';
import { settingsAtom } from '../../atoms/Settings';
import {
  CookieConsentPreference,
  getStoredCookiePreference,
  storeCookiePreference,
} from '../../utils/CookieConsent';
import { useLocalizedText } from '../../hooks/useLocalizedText';
import { sharedStyles } from '../../utils/Style';

export const CookieConsentBanner = () => {
  const [preference, setPreference] = useState(getStoredCookiePreference());

  const t = useLocalizedText();
  const settings = useRecoilValue(settingsAtom);

  const handleSelection = (choice: CookieConsentPreference) => {
    storeCookiePreference(choice);
    setPreference(choice);
  };

  if (preference !== null) return null;

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        width: '100%',
        p: 2,
        boxSizing: 'border-box',
        backgroundColor: settings.settingsV1.storefront_primary_color,
        borderColor: settings.settingsV1.storefront_secondary_color,
        borderTopStyle: 'solid',
        display: 'flex',
        flexDirection: 'row',
        gap: 1.5,
        alignItems: 'center',
        justifyContent: 'space-around',
      }}
    >
      <Typography
        sx={{ color: settings.settingsV1.storefront_secondary_color }}
      >
        {t('cookie_consent.description')}
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <Button
          variant='outlined'
          onClick={() => handleSelection('allow')}
          sx={{
            ...sharedStyles.buttonText,
            borderColor: settings.settingsV1.storefront_secondary_color,
            color: settings.settingsV1.storefront_secondary_color,
            textWrap: 'nowrap',
          }}
        >
          {t('cookie_consent.accept')}
        </Button>

        <Button
          onClick={() => handleSelection('deny')}
          sx={{
            ...sharedStyles.buttonText,
            color: settings.settingsV1.storefront_secondary_color,
            textWrap: 'nowrap',
          }}
        >
          {t('cookie_consent.deny')}
        </Button>
      </Box>
    </Paper>
  );
};
